import { TenderState } from "@/graphql/__generated__/graphql";
import { FormGroupHeader } from "@/components/shared";
import { useTranslation } from "react-i18next";
import { useUpdateTenderStateMutationHook } from "@/hooks";
import { useOutletContext, useParams } from "react-router-dom";
import SubmissionOptionComponent from "./SubmissionOptionComponent";
import { EditTenderContext } from "@/layouts/EditTenderLayout";
import WonLostOptionComponent from "./WonLostOptionComponent";
import { TenderWonLostResultComponent } from "../Components";
import { Card } from "@/components/ui/card";
import RequestRecalculationComponent from "./RequestRecalculationComponent";

function SubmissionComponent() {
  const { t } = useTranslation(["translation", "components"]);
  const { updateTenderStateMutation, loading } = useUpdateTenderStateMutationHook();
  const { tenderID } = useParams<{ tenderID: string }>();
  const { tenderByIdData, isTenderOwner } = useOutletContext<EditTenderContext>();

  const tenderState = tenderByIdData?.fetchTenderById?.state;
  const reasonForLoss = tenderByIdData?.fetchTenderById?.reasonForLoss;

  return (
    <div>
      <FormGroupHeader
        title={t("edittender.submission.title")}
        description={t("edittender.submission.description")}
        className="pr-4 pl-2"
      />
      <div className="flex flex-col gap-4 pb-[300px] pr-4 pl-2">
        {
          tenderState !== TenderState.Won && tenderState !== TenderState.Lost && (
            isTenderOwner ? (
              <>
                {tenderState === TenderState.ReadyToSubmit && (
                  <SubmissionOptionComponent
                    updateTenderStateMutation={updateTenderStateMutation}
                    loading={loading}
                    tenderID={tenderID}
                  />
                )}
                {tenderState === TenderState.Submitted && (
                  <WonLostOptionComponent
                    updateTenderStateMutation={updateTenderStateMutation}
                    loading={loading}
                    tenderID={tenderID}
                  />
                )}
                <RequestRecalculationComponent tenderID={tenderID} />
              </>
            ) : (
              <Card className="p-4 text-sm text-slate-400">
                {t("edittender.submission.notowner")}
              </Card>
            )
          )
        }

        <TenderWonLostResultComponent tenderState={tenderState} reasonForLoss={reasonForLoss} />
      </div>
    </div>
  );
}

export default SubmissionComponent;
